import { CloudCommand } from "../types.js";

export const refreshProspect: CloudCommand = {
    action: "REGULAR_PROFILE/REFRESH_PROSPECT",
    commandName: "prospects.refreshProspect",
    buildPayload: ({ identifiers }) => ({ identifiers }),
};
